import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PackageBoxes } from '@fittrack/ui';
import { useMember } from '../context/MemberContext';
import { config } from '../config';
import apiClient from '../api/client';
import './EnrollPage.css';

export default function EnrollPage() {
  const { member } = useMember();
  const navigate = useNavigate();
  const [signupUrl, setSignupUrl] = useState<string | null>(null);
  const [signupUrlLoaded, setSignupUrlLoaded] = useState(false);

  // Active members at a site with a custom MembersAppActiveSignupURL configured
  // (e.g. an add-on-purchase page distinct from the standard package list) get
  // that exact URL instead of the embedded package list below -- it can point
  // anywhere, so it stays an iframe rather than being rendered as a component.
  useEffect(() => {
    if (!member?.personId) { setSignupUrlLoaded(true); return; }
    apiClient.get(`/PwaDashboard/signupurl/${member.personId}`)
      .then(res => setSignupUrl(res.data?.data?.signupUrl ?? null))
      .catch(() => setSignupUrl(null))
      .finally(() => setSignupUrlLoaded(true));
  }, [member?.personId]);

  if (!member?.siteId) {
    return (
      <div className="enroll-page">
        <p className="enroll-empty">No site information available.</p>
      </div>
    );
  }

  if (!signupUrlLoaded) {
    return <div className="enroll-page" />;
  }

  if (signupUrl) {
    return (
      <div className="enroll-page">
        <iframe className="enroll-iframe" src={signupUrl} title="Membership Signup" allow="payment" />
      </div>
    );
  }

  return (
    <div className="enroll-page">
      <PackageBoxes
        companyId={config.onlineName}
        siteId={member.siteId}
        apiUrl={config.apiUrl}
        authToken={localStorage.getItem('apiKey') ?? undefined}
        onPackageSelect={(packageId) => navigate(`/enroll/join/${packageId}/step1`)}
      />
    </div>
  );
}
